import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: '[col-template]' })
export class ColumnTemplateDirective {
    constructor(public template: TemplateRef<any>) { }
}